import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import img from '../img/error_offers.png';
import imgWebp from '../img/error_offers.webp';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isError: false
    };
    this.strings = new LocalizedStrings({
      ru: {
        title: 'Извините, но что-то пошло не так!',
        subtitle: 'Попробуйте перейти на Главную страницу сайта',
        link: 'Главная'
      },
      ua: {
        title: 'Вибачте, але щось пішло не так!',
        subtitle: 'Спробуйте перейти на Головну сторінку сайту',
        link: 'Головна'
      },
    });
  };

  componentDidMount = () => {
    this.strings.setLanguage(this.props.locale);
  }

  static getDerivedStateFromError = () => {
    return { isError: true };
  }

  render() {
    if (this.state.isError) {
      return (
        <div className="error-boundary">
          <picture>
            <source srcSet={imgWebp} type="image/webp" />
            <img src={img} alt="error" />
          </picture>

          <h1 className="error-boundaty-title">{this.strings.title}</h1>
          <h2 className="error-boundaty-subtitle">{this.strings.subtitle}</h2>
          <a href={this.props.locale === 'ua' ? '/uk/kasko' : '/kasko'} className="btn btn-bg">{this.strings.link}</a>
        </div>
      );
    } else {
      return this.props.children;
    }
  }
}

export default ErrorBoundary;
